"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Crash = _interopRequireDefault(require("Icons/Crash"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ErrorRecoveryModal extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open,
      onClose: props.onClose,
      "scroll-area": ".front-page, .back-page, .simple-page",
      bemit: ['error-recovery', 'medium', 'simple'],
      "close-label": "Fermer"
    }, /*#__PURE__*/_react.default.createElement(_Crash.default, {
      className: (0, _bemit.default)('c-icon', ['crash'])
    }), (0, _getFormStatus.default)({
      error: 'L\'application vient de récupérer après une erreur imprévue. '
    }), (0, _getFormStatus.default)({
      statement: 'Notre équipe en a été informée, vous n\'avez aucune action à effectuer. N\'hésitez pas à nous contacter si le problème persiste.'
    }));
    return output;
  }
}
exports.default = ErrorRecoveryModal;
